import { Button, Divider, Grid, ThemeProvider, Typography } from '@mui/material';
import React from 'react';
import {
  List,
  Datagrid,
  EditButton,
  TextField,
  ReferenceField,
  DateField,
  TopToolbar,
  CreateButton,
  ExportButton,
  FilterButton,
} from 'react-admin';
import MainLayout from '../layout/MainLayout';
import { StatusField } from './components/StatusField';
import { terminalFilters } from './TerminalFilter';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { useState } from 'react';
import { useEffect } from 'react'
import Color from '../layout/color/Color';
import theme from '../layout/theme/Theme';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid',
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};

function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width
  };
}

export const TerminalList = () => {
  const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
  const [currentScreenPx, setCurrentScreenPx] = useState('');

  useEffect(() => {
    function handleResize() {
      setCurrentScreen(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setCurrentScreenPx((currentScreen.width - 70) + 'px')
  }, [currentScreen])

  return (
    <ThemeProvider theme={theme}>
      <MainLayout>
        <Grid sx={{ textAlign: 'left' }}>
          <Button
            endIcon={<PointOfSaleIcon sx={{ color: Color.Main }} />}
            sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Terminal Management</Typography>
          </Button>
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <List filters={terminalFilters} actions={<TerminalListActions />}>
          <Datagrid
            bulkActionButtons={false}
            sx={{
              '& .RaDatagrid-tableWrapper': {
                xs: {
                  overflowX: 'scroll',
                  width: currentScreenPx,
                  overflowY: 'hidden',
                  mx: '20px',
                  whiteSpace: 'nowrap'
                },
                md: {
                  overflowX: 'scroll',
                  width: currentScreenPx,
                  overflowY: 'hidden',
                  mx: '20px',
                  whiteSpace: 'nowrap'
                },
                lg: {
                  overflowX: 'scroll',
                  width: '100%',
                  overflowY: 'hidden',
                  whiteSpace: 'nowrap'
                },
                xl: {
                  overflowX: 'scroll',
                  width: '100%',
                  overflowY: 'hidden',
                  whiteSpace: 'nowrap'
                }
              }
            }}
          >
            <ReferenceField
              source="submerchantID"
              reference="SubMerchant"
              label="Submerchant"
              link={false}
            >
              <TextField source="name" label="Submerchant"  />
            </ReferenceField>
            <TextField source="alias" />
            <DateField source="created_at" />
            <StatusField source="status" />
            <EditButton />
          </Datagrid>
        </List>
      </MainLayout>
    </ThemeProvider>


  );
};

const TerminalListActions = () => {
  return (
    <TopToolbar>
      <FilterButton sx={{ color: Color.Main}}/>
      <CreateButton label="Create New" sx={saveButton} />
      <ExportButton sx={backButton} />
    </TopToolbar>
  );
};
